import { ModelSetTransformer, ModelTransformer } from '../common/common.model';

export interface ExtTeamDistributionByPillarPillar {
    pillarID: number;
    pillarName: string;
    pillarInitials: string;
    negative: number;
    positive: number;
    closeToTarget: number;
    imageFilename: string;
}

interface TeamDistributionByPillarPillar {
    pillarName: string;
    pillarInitials: string;
    negative: number;
    positive: number;
    closeToTarget: number;
}

export interface TeamDistributionByPillar {
    d3: { options?: any; data: any };
}

class TeamDistributionByPillarPillarModelTransformer
    implements
        ModelTransformer<
            TeamDistributionByPillarPillar,
            ExtTeamDistributionByPillarPillar
        >
{
    transform(
        model: ExtTeamDistributionByPillarPillar,
    ): TeamDistributionByPillarPillar {
        return {
            pillarName: model.pillarName,
            pillarInitials: model.pillarInitials,
            negative: model.negative,
            positive: model.positive,
            closeToTarget: model.closeToTarget,
        };
    }
}

class TeamDistributionByPillarPillarModelSetTransformer extends ModelSetTransformer<
    TeamDistributionByPillarPillar,
    ExtTeamDistributionByPillarPillar
> {
    protected newTransformer(): ModelTransformer<
        TeamDistributionByPillarPillar,
        ExtTeamDistributionByPillarPillar
    > {
        return new TeamDistributionByPillarPillarModelTransformer();
    }
}

export class TeamDistributionByPillarModelTransformer
    implements
        ModelTransformer<
            TeamDistributionByPillar,
            ExtTeamDistributionByPillarPillar[]
        >
{
    transform(
        model: ExtTeamDistributionByPillarPillar[],
    ): TeamDistributionByPillar {
        const pillars =
            new TeamDistributionByPillarPillarModelSetTransformer().transform(
                model,
            );
        const data = [
            {
                key: null,
                color: '#ea5562',
                values: null,
            },
            {
                key: null,
                color: '#6e7277',
                values: null,
            },
            {
                key: null,
                color: '#75c743',
                values: null,
            },
        ];
        data.forEach((value, index) => {
            value.values = pillars.map((pillar) => {
                return {
                    x: pillar.pillarInitials,
                    y:
                        index === 0
                            ? pillar.negative
                            : index === 1
                            ? pillar.closeToTarget
                            : pillar.positive,
                };
            });
        });
        return {
            d3: {
                data,
            },
        };
    }
}

export function validateTeamDistributionByPillar(
    model: TeamDistributionByPillar,
): void {
    const valid =
        model != null &&
        model.d3.data.find(
            (value) => value.values == null || value.values.length === 0,
        ) == null;
    if (!valid) {
        throw new Error('TeamDistributionByPillar not valid');
    }
}
